import Snackbar from '@mui/material/Snackbar';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { Theme as ThemeMui5 } from '@mui/material/styles/createTheme';
import { StyledButtonMui5 } from 'components/atoms/StyledButton';
import Alert from '@mui/material/Alert';
import { DialogTitle } from '../../dashboard/components/Dialog/DialogTitle';
import { useScreenSize } from 'hooks/useScreenSize';
import { styled } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { useState } from 'react';
import MakeMeAnOfferForm from '../../../components/organisms/MakeMeAnOfferForm';

const FormContainer = styled('div', {
  shouldForwardProp: (props) => props !== 'isCompact',
})<{
  isCompact?: boolean;
}>(
  ({ isCompact }) => `
  display: flex;
  flex-direction: column;
  height: 100%;
  max-width: ${isCompact ? 'auto' : '450px'};
  min-width: ${isCompact ? 'auto' : '450px'};
  `,
);

const dialogTitleStyles: SxProps<ThemeMui5> = (theme) => ({
  '&.MuiTypography-root': {
    boxShadow: 'none',
    padding: theme.spacing(2, 3, 0, 3),
  },
});

const dialogContentStyles: SxProps<ThemeMui5> = (theme) => ({
  '&.MuiDialogContent-root': {
    paddingTop: 0,
    paddingBottom: theme.spacing(3),
  },
});

const RequestCarButton = (): JSX.Element => {
  const { isExtraSmallScreen } = useScreenSize();
  const [isDialogOpen, toggleDialog] = useState(false);
  const [isSnackbarOpen, toggleSnackbar] = useState(false);

  return (
    <>
      <StyledButtonMui5
        color='secondary'
        onClick={() => {
          toggleDialog(true);
        }}
      >
        Make Me an Offer
      </StyledButtonMui5>
      <Dialog
        fullScreen={isExtraSmallScreen}
        open={isDialogOpen}
        onClose={() => toggleDialog(false)}
      >
        <DialogTitle
          title=''
          sx={dialogTitleStyles}
          onClose={() => toggleDialog(false)}
        >
          <Typography variant='h5' gutterBottom>
            Make Me an Offer
          </Typography>
        </DialogTitle>
        <DialogContent sx={dialogContentStyles}>
          <FormContainer isCompact={isExtraSmallScreen}>
            <MakeMeAnOfferForm
              onSubmit={() => {
                toggleSnackbar(true);
                toggleDialog(false);
              }}
            />
          </FormContainer>
        </DialogContent>
      </Dialog>
      <Snackbar
        open={isSnackbarOpen}
        autoHideDuration={6000}
        onClose={() => toggleSnackbar(false)}
      >
        <Alert onClose={() => toggleSnackbar(false)} severity='success'>
          Offer was requested
        </Alert>
      </Snackbar>
    </>
  );
};

export default RequestCarButton;
